export default "__VITE_ASSET__DAe3pGe$__"